import React from 'react';
import PropTypes from 'prop-types';

const RC = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.02636 6.27686H4.58136V7.47686H7.02636H7.16886H10.7014V6.27686H7.16886H7.02636Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M7.58136 4.25488H4.58136V5.45488H7.58136H7.75386H12.0814V4.25488H7.75386H7.58136Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M9 12L9.75 9.75H15.25L16 12M15.25 14.5C15.0511 14.5 14.8603 14.421 14.7197 14.2803C14.579 14.1397 14.5 13.9489 14.5 13.75C14.5 13.5511 14.579 13.3603 14.7197 13.2197C14.8603 13.079 15.0511 13 15.25 13C15.4489 13 15.6397 13.079 15.7803 13.2197C15.921 13.3603 16 13.5511 16 13.75C16 13.9489 15.921 14.1397 15.7803 14.2803C15.6397 14.421 15.4489 14.5 15.25 14.5ZM9.75 14.5C9.55109 14.5 9.36032 14.421 9.21967 14.2803C9.07902 14.1397 9 13.9489 9 13.75C9 13.5511 9.07902 13.3603 9.21967 13.2197C9.36032 13.079 9.55109 13 9.75 13C9.94891 13 10.1397 13.079 10.2803 13.2197C10.421 13.3603 10.5 13.5511 10.5 13.75C10.5 13.9489 10.421 14.1397 10.2803 14.2803C10.1397 14.421 9.94891 14.5 9.75 14.5ZM15.96 9.5C15.86 9.21 15.58 9 15.25 9H9.75C9.42 9 9.14 9.21 9.04 9.5L8 12.5V16.5C8 16.6326 8.05268 16.7598 8.14645 16.8536C8.24021 16.9473 8.36739 17 8.5 17H9C9.13261 17 9.25979 16.9473 9.35355 16.8536C9.44732 16.7598 9.5 16.6326 9.5 16.5V16H15.5V16.5C15.5 16.6326 15.5527 16.7598 15.6464 16.8536C15.7402 16.9473 15.8674 17 16 17H16.5C16.6326 17 16.7598 16.9473 16.8536 16.8536C16.9473 16.7598 17 16.6326 17 16.5V12.5L15.96 9.5Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M9 12L9.75 9.75H15.25L16 12M15.25 14.5C15.0511 14.5 14.8603 14.421 14.7197 14.2803C14.579 14.1397 14.5 13.9489 14.5 13.75C14.5 13.5511 14.579 13.3603 14.7197 13.2197C14.8603 13.079 15.0511 13 15.25 13C15.4489 13 15.6397 13.079 15.7803 13.2197C15.921 13.3603 16 13.5511 16 13.75C16 13.9489 15.921 14.1397 15.7803 14.2803C15.6397 14.421 15.4489 14.5 15.25 14.5ZM9.75 14.5C9.55109 14.5 9.36032 14.421 9.21967 14.2803C9.07902 14.1397 9 13.9489 9 13.75C9 13.5511 9.07902 13.3603 9.21967 13.2197C9.36032 13.079 9.55109 13 9.75 13C9.94891 13 10.1397 13.079 10.2803 13.2197C10.421 13.3603 10.5 13.5511 10.5 13.75C10.5 13.9489 10.421 14.1397 10.2803 14.2803C10.1397 14.421 9.94891 14.5 9.75 14.5ZM15.96 9.5C15.86 9.21 15.58 9 15.25 9H9.75C9.42 9 9.14 9.21 9.04 9.5L8 12.5V16.5C8 16.6326 8.05268 16.7598 8.14645 16.8536C8.24021 16.9473 8.36739 17 8.5 17H9C9.13261 17 9.25979 16.9473 9.35355 16.8536C9.44732 16.7598 9.5 16.6326 9.5 16.5V16H15.5V16.5C15.5 16.6326 15.5527 16.7598 15.6464 16.8536C15.7402 16.9473 15.8674 17 16 17H16.5C16.6326 17 16.7598 16.9473 16.8536 16.8536C16.9473 16.7598 17 16.6326 17 16.5V12.5L15.96 9.5Z"
      stroke="#130951"
      strokeWidth="0.4"
    />
    <path
      d="M14.5 9V3C14.5 2.44772 14.0523 2 13.5 2H3.5C2.94772 2 2.5 2.44772 2.5 3V13C2.5 13.5523 2.94772 14 3.5 14H8.5"
      stroke="#130951"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
  </svg>
);

RC.propTypes = {
  fill: PropTypes.string,
};

export default RC;
